const iconPaths = {
  apps: (
    <>
      <rect x="3.5" y="3.5" width="6" height="6" rx="1.5" />
      <rect x="14.5" y="3.5" width="6" height="6" rx="1.5" />
      <rect x="3.5" y="14.5" width="6" height="6" rx="1.5" />
      <rect x="14.5" y="14.5" width="6" height="6" rx="1.5" />
    </>
  ),
  "apps-outline": (
    <>
      <rect x="3.5" y="3.5" width="6" height="6" rx="1.5" />
      <rect x="14.5" y="3.5" width="6" height="6" rx="1.5" />
      <rect x="3.5" y="14.5" width="6" height="6" rx="1.5" />
      <rect x="14.5" y="14.5" width="6" height="6" rx="1.5" />
    </>
  ),
  business: (
    <>
      <path d="M5 20.5V5.5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v15" />
      <path d="M3.5 20.5h17" />
      <path d="M9 20.5v-4h6v4" />
      <path d="M8 7h1.5M14.5 7H16M8 11h1.5M14.5 11H16" />
    </>
  ),
  "business-outline": (
    <>
      <path d="M5 20.5V5.5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v15" />
      <path d="M3.5 20.5h17" />
      <path d="M9 20.5v-4h6v4" />
      <path d="M8 7h1.5M14.5 7H16M8 11h1.5M14.5 11H16" />
    </>
  ),
  "briefcase-outline": (
    <>
      <rect x="4" y="7.5" width="16" height="12" rx="2" />
      <path d="M9 7.5V5.8c0-.95.75-1.7 1.7-1.7h2.6c.95 0 1.7.75 1.7 1.7v1.7" />
      <path d="M4 12h16" />
      <path d="M10 12v1.5h4V12" />
    </>
  ),
  "search-outline": (
    <>
      <circle cx="10.8" cy="10.8" r="6.4" />
      <path d="m15.5 15.5 4.2 4.2" />
    </>
  ),
  person: (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5.5 20.5c.75-3.7 3.1-5.6 6.5-5.6s5.75 1.9 6.5 5.6" />
    </>
  ),
  "person-outline": (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5.5 20.5c.75-3.7 3.1-5.6 6.5-5.6s5.75 1.9 6.5 5.6" />
    </>
  ),
  requester: (
    <>
      <path d="M8.5 13.5V6.2a1.6 1.6 0 0 1 3.2 0v6.3" />
      <path d="M11.7 12.5V5.1a1.55 1.55 0 0 1 3.1 0v7.8" />
      <path d="M14.8 13V7.3a1.45 1.45 0 0 1 2.9 0v7.3" />
      <path d="M8.5 13.5 6.9 11.9a1.55 1.55 0 0 0-2.2 2.2l4.25 4.25c1.2 1.2 2.85 1.9 4.55 1.9h.8c2.25 0 4.1-1.85 4.1-4.1v-1.55" />
    </>
  ),
  "hand-left-outline": (
    <>
      <path d="M8.5 13.5V6.2a1.6 1.6 0 0 1 3.2 0v6.3" />
      <path d="M11.7 12.5V5.1a1.55 1.55 0 0 1 3.1 0v7.8" />
      <path d="M14.8 13V7.3a1.45 1.45 0 0 1 2.9 0v7.3" />
      <path d="M8.5 13.5 6.9 11.9a1.55 1.55 0 0 0-2.2 2.2l4.25 4.25c1.2 1.2 2.85 1.9 4.55 1.9h.8c2.25 0 4.1-1.85 4.1-4.1v-1.55" />
    </>
  ),
  helper: (
    <>
      <path d="M14.6 4.4a4.15 4.15 0 0 0 4.95 4.95l-8.8 8.8a2.25 2.25 0 0 1-3.2-3.2l8.8-8.8Z" />
      <path d="M6.6 17.4 3.8 20.2" />
      <path d="M16.2 3.8 20.2 7.8" />
    </>
  ),
  "construct-outline": (
    <>
      <path d="M14.6 4.4a4.15 4.15 0 0 0 4.95 4.95l-8.8 8.8a2.25 2.25 0 0 1-3.2-3.2l8.8-8.8Z" />
      <path d="M6.6 17.4 3.8 20.2" />
      <path d="M16.2 3.8 20.2 7.8" />
    </>
  ),
  share: (
    <>
      <circle cx="18" cy="5.5" r="2.5" />
      <circle cx="6" cy="12" r="2.5" />
      <circle cx="18" cy="18.5" r="2.5" />
      <path d="m8.25 10.9 7.5-4.1M8.25 13.1l7.5 4.1" />
    </>
  ),
  flash: <path d="M13 2.8 5.7 13H11l-1 8.2L18.3 10H13l.1-7.2Z" />,
  chat: (
    <>
      <path d="M4 6.5c0-1.65 1.35-3 3-3h10c1.65 0 3 1.35 3 3v7c0 1.65-1.35 3-3 3H9l-5 4v-14Z" />
      <path d="M8 9.5h8M8 12.5h5" />
    </>
  ),
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2" />
      <path d="m4.5 7 7.5 6 7.5-6" />
    </>
  ),
  notification: (
    <>
      <path d="M18 10.5c0-3.55-2.15-6-6-6s-6 2.45-6 6c0 4.4-2 5.4-2 5.4h16s-2-1-2-5.4Z" />
      <path d="M9.5 18.5a2.7 2.7 0 0 0 5 0" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.2 12.2 2.3 2.3 5.3-5.3" />
    </>
  ),
  chevron: <path d="m9 5.5 6.5 6.5L9 18.5" />,
};

const ioniconGlyphs = {
  apps: 61729,
  "apps-outline": 61730,
  business: 61894,
  "business-outline": 61895,
  person: 62629,
  "person-outline": 62636,
  helper: 62087,
  "construct-outline": 62087,
  requester: 62300,
  "hand-left-outline": 62300,
  "checkmark-circle": 61982,
  chevron: 62011,
  "chevron-forward": 62011,
  share: 62837,
  "share-social-outline": 62837,
  flash: 62234,
  "flash-outline": 62234,
  chat: 61971,
  "chatbubble-ellipses-outline": 61971,
  mail: 62516,
  "mail-outline": 62516,
  notification: 62591,
  "notifications-outline": 62591,
  "notifications": 62581,
  "information-circle-outline": 62361,
  "alert-circle-outline": 61716,
  "warning-outline": 63017,
  "reader-outline": 62732,
  calendar: 61903,
  "calendar-outline": 61910,
  "call-outline": 61913,
  camera: 61915,
  "camera-outline": 61916,
  "close-circle": 62027,
  "location-outline": 62405,
  pencil: 62620,
  "pencil-outline": 62621,
  "rocket-outline": 62792,
  "shield-checkmark-outline": 62841,
  "sparkles-outline": 62861,
  "time-outline": 62942,
};

export default function OlitaskHeaderIcon({ name, className = "", size = 24, title }) {
  const glyph = ioniconGlyphs[name];

  if (glyph) {
    return (
      <span
        aria-hidden={title ? undefined : "true"}
        className={`olitask-ionicon ${className}`.trim()}
        role={title ? "img" : undefined}
        style={{
          "--olitask-ionicon-size": `${size}px`,
        }}
        title={title}
      >
        {String.fromCodePoint(glyph)}
      </span>
    );
  }

  return (
    <svg
      aria-hidden={title ? undefined : "true"}
      className={className}
      fill="none"
      height={size}
      role={title ? "img" : undefined}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      viewBox="0 0 24 24"
      width={size}
    >
      {title ? <title>{title}</title> : null}
      {iconPaths[name] || iconPaths.apps}
    </svg>
  );
}
